import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { loginUser, logoutUser } from './authActions'
import { localStorageKeys, routeUrls } from 'src/utils/constants'

type InitialStateType = {
  isAuthenticated: boolean
  loading: boolean
  token: string | null
  userInfo: {
    id: number
    email: string
    name: string | null | undefined
  } | null
  error: string | null
  success: boolean
}

const initialState: InitialStateType = {
  loading: false,
  token: localStorage.getItem(localStorageKeys.accessToken) || null, // for storing the JWT
  userInfo: (() => {
    const user = localStorage.getItem(localStorageKeys.user) || null
    if (user) {
      try {
        return JSON.parse(user)
      } catch (error) {
        return null
      }
    }
    return null
  })(), // for user object
  error: null,
  success: false, // for monitoring the registration process.
  isAuthenticated: !!(
    localStorage.getItem(localStorageKeys.accessToken) &&
    localStorage.getItem(localStorageKeys.user)
  ),
}

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setAuthErrorReducer(state, action: PayloadAction<string>) {
      state.error = action.payload
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(loginUser.pending, (state) => {
        state.loading = true
        state.error = null
        state.token = null
        // state.role = null
        state.userInfo = null
        state.success = false
        state.isAuthenticated = false
        localStorage.removeItem(localStorageKeys.accessToken)
        localStorage.removeItem(localStorageKeys.user)
      })
      .addCase(loginUser.fulfilled, (state, action) => {
        state.loading = false
        state.success = true
        state.token = action.payload.token
        // state.role = action.payload.user.category
        state.userInfo = action.payload.user
        state.error = null
        state.isAuthenticated = true

        localStorage.setItem(localStorageKeys.accessToken, action.payload.token)
        localStorage.setItem(localStorageKeys.user, JSON.stringify(action.payload.user))
      })
      .addCase(loginUser.rejected, (state, action: any) => {
        state.loading = false
        state.error = action.payload
        state.token = null
        // state.role = null
        state.userInfo = null
        state.success = false
        state.isAuthenticated = false
        localStorage.removeItem(localStorageKeys.accessToken)
        localStorage.removeItem(localStorageKeys.user)
      })

      .addCase(logoutUser.pending, (state) => {
        state.loading = true
      })
      .addCase(logoutUser.fulfilled, (state, action) => {
        state.loading = false
        state.success = false
        state.token = null
        state.userInfo = null
        state.error = null
        state.isAuthenticated = false
        localStorage.clear()
      })
      .addCase(logoutUser.rejected, (state, action: any) => {
        state.loading = false
      })
  },
})
export const { setAuthErrorReducer } = authSlice.actions

export default authSlice.reducer
